<template>
  <!-- Add Company -->
  <div
    class="modal fade"
    id="add_company"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">
            {{ isEditMode ? "Edit" : "Add New" }} Company
          </h4>
          <button
            type="button"
            class="btn-close custom-btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i class="ti ti-x"></i>
          </button>
        </div>
        <form ref="companyForm" @submit.prevent="submitForm" novalidate>
          <div class="contact-grids-tab">
            <ul class="nav nav-underline" id="myTab" role="tablist">
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link active"
                  id="info-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#basic-info"
                  type="button"
                  role="tab"
                  aria-selected="true"
                >
                  Basic Information
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link"
                  id="address-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#address"
                  type="button"
                  role="tab"
                  aria-selected="false"
                >
                  Address
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link"
                  id="social-profile-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#social-profile"
                  type="button"
                  role="tab"
                  aria-selected="false"
                >
                  Social Profiles
                </button>
              </li>
            </ul>
          </div>
          <div class="tab-content" id="myTabContent">
            <!-- BASIC INFO TAB -->
            <div
              class="tab-pane fade show active"
              id="basic-info"
              role="tabpanel"
              aria-labelledby="info-tab"
              tabindex="0"
            >
              <div class="modal-body pb-0">
                <div class="row">
                  <div class="col-md-12">
                    <div
                      class="d-flex align-items-center flex-wrap row-gap-3 bg-light w-100 rounded p-3 mb-4"
                    >
                      <div
                        class="d-flex align-items-center justify-content-center avatar avatar-xxl rounded-circle border border-dashed me-2 flex-shrink-0 text-dark frames"
                      >
                        <img
                          v-if="form.imageUrl"
                          :src="form.imageUrl"
                          class="rounded-circle"
                          style="width: 60px; height: 60px"
                        />
                        <i v-else class="ti ti-photo text-gray-2 fs-16"></i>
                      </div>
                      <div class="profile-upload">
                        <div class="mb-2">
                          <h6 class="mb-1">Upload Company Logo</h6>
                          <p class="fs-12">Image should be below 4 mb</p>
                        </div>
                        <div class="profile-uploader d-flex align-items-center">
                          <div
                            class="drag-upload-btn btn btn-sm btn-primary me-2"
                          >
                            Upload
                            <input
                              type="file"
                              class="form-control image-sign"
                              accept="image/*"
                              @change="onImageChange"
                            />
                          </div>
                          <a
                            v-if="form.imageUrl"
                            href="javascript:void(0);"
                            class="btn btn-light btn-sm"
                            @click="removeImage"
                            >Cancel</a
                          >
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label"
                        >Company Name <span class="text-danger">*</span></label
                      >
                      <input
                        type="text"
                        class="form-control"
                        v-model="form.company_name"
                        required
                        placeholder="Enter registered company name"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label"
                        ><span class="text-danger">*</span>Email</label
                      >
                      <input
                        type="email"
                        class="form-control"
                        v-model="form.email"
                        required
                        placeholder="e.g. info@company.com"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label"
                        ><span class="text-danger">*</span>Company Pin</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        v-model="form.kra_pin"
                        required
                        placeholder="Enter tax / KRA PIN"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label"
                        >Phone Number <span class="text-danger">*</span></label
                      >
                      <input
                        type="text"
                        class="form-control"
                        v-model="form.phone"
                        required
                        placeholder="e.g. +254 700 000000"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label">Phone Number 2</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="form.phone_two"
                        placeholder="Optional secondary contact"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label">Fax</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="form.fax"
                        placeholder="Optional fax number"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label">Status</label>
                      <vue-select
                        :options="CrmStat"
                        placeholder="Select status"
                        v-model="form.status"
                        :clearable="false"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label">Onboarding Type</label>
                      <vue-select
                        :options="onboardingOptions"
                        placeholder="Select onboarding type"
                        v-model="form.onboarding_source"
                        :clearable="false"
                      />
                      <small class="text-muted">
                        Use <strong>Migrated</strong> when onboarding a company
                        with legacy data such as Pay100 / Access.
                      </small>
                    </div>
                  </div>

                  <div v-if="!isEditMode" class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label">Plan</label>
                      <select class="form-select" v-model="form.plan_id">
                        <option
                          v-for="plan in assignablePlans"
                          :key="plan.id"
                          :value="String(plan.id)"
                        >
                          {{ plan.name }}
                          <template v-if="plan.slug === 'basic-plan'"> (default)</template>
                        </option>
                      </select>
                      <small class="text-muted">
                        New companies get an active paid annual license on this plan.
                        You can change it later from company details.
                      </small>
                    </div>
                  </div>

                  <template v-if="showWorkspaceProvision">
                    <div class="col-md-12">
                      <div class="border rounded p-3 mb-3 bg-light">
                        <div class="form-check mb-3">
                          <input
                            id="provision_workspace"
                            v-model="form.provision_workspace"
                            class="form-check-input"
                            type="checkbox"
                          />
                          <label class="form-check-label" for="provision_workspace">
                            Provision isolated tenant workspace after creating this company
                          </label>
                        </div>
                        <div v-if="form.provision_workspace" class="row">
                          <div class="col-md-8">
                            <label class="form-label">Workspace URL slug</label>
                            <input
                              v-model="form.workspace_slug"
                              type="text"
                              class="form-control"
                              placeholder="acme-corp"
                              @input="slugManuallyEdited = true"
                            />
                            <small v-if="slugPreviewUrl" class="text-muted d-block mt-1">
                              Preview: {{ slugPreviewUrl }}
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>

                  <!-- EXISTING CURRENCY FIELD (KEPT INTACT) -->
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label">Currency</label>
                      <vue-select
                        :options="DolarSel"
                        id="dolarsel"
                        placeholder="Select currency"
                        v-model="form.currency"
                      />
                    </div>
                  </div>

                  <!-- NEW: CURRENCY CODE (MANDATORY) -->
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label"
                        >Currency Code <span class="text-danger">*</span></label
                      >
                      <input
                        type="text"
                        class="form-control"
                        v-model="form.currency_code"
                        required
                        placeholder="e.g. KES, USD, EUR"
                      />
                    </div>
                  </div>

                  <!-- NEW: TIMEZONE (MANDATORY) -->
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label"
                        >Timezone <span class="text-danger">*</span></label
                      >
                      <vue-select
                        :options="timezones"
                        placeholder="Select timezone"
                        v-model="form.timezone"
                        :clearable="false"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label">Website</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="form.website_url"
                        placeholder="e.g. https://www.company.com"
                      />
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="mb-3">
                      <label class="form-label">About </label>
                      <textarea
                        class="form-control"
                        v-model="form.about"
                        placeholder="Short company profile (industry, services, etc.)"
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>

              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-light me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  class="btn btn-primary"
                  :disabled="submitting || provisioningWorkspace"
                >
                  <span
                    v-if="submitting || provisioningWorkspace"
                    class="spinner-border spinner-border-sm me-1"
                  ></span
                  >{{
                    provisioningWorkspace
                      ? "Provisioning workspace..."
                      : submitting
                        ? "Saving..."
                        : "Save"
                  }}
                </button>
              </div>
            </div>

            <!-- ADDRESS TAB -->
            <div
              class="tab-pane fade"
              id="address"
              role="tabpanel"
              aria-labelledby="address-tab"
              tabindex="0"
            >
              <div class="modal-body pb-0">
                <div class="row">
                  <div class="col-md-12">
                    <div class="mb-3">
                      <label class="form-label"
                        >Address <span class="text-danger">*</span></label
                      >
                      <input
                        type="text"
                        class="form-control"
                        v-model="form.address"
                        required
                        placeholder="Head office street address"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label">State / Region</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="form.state"
                        placeholder="State, county or region"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label">
                        Country <span class="text-danger">*</span>
                      </label>

                      <div class="dropdown w-100">
                        <button
                          class="btn btn-outline-secondary w-100 d-flex justify-content-between align-items-center"
                          type="button"
                          data-bs-toggle="dropdown"
                        >
                          <span class="text-truncate">
                            {{ form.country || "Select country" }}
                          </span>
                          <i class="ti ti-chevron-down ms-2"></i>
                        </button>

                        <div class="dropdown-menu p-2 w-100 shadow">
                          <input
                            v-model="countryQuery"
                            type="text"
                            class="form-control mb-2"
                            placeholder="Search country..."
                            autocomplete="off"
                          />
                          <div
                            class="search-list"
                            style="max-height: 240px; overflow-y: auto"
                          >
                            <button
                              v-for="c in filteredCountries"
                              :key="c.country"
                              type="button"
                              class="dropdown-item text-truncate"
                              @click="chooseCountry(c)"
                            >
                              {{ c.country }}
                            </button>
                            <div
                              v-if="filteredCountries.length === 0"
                              class="text-center py-2 small text-muted"
                            >
                              No country found
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- NEW: COUNTRY CODE (MANDATORY) -->
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label"
                        >Country Code <span class="text-danger">*</span></label
                      >
                      <input
                        type="text"
                        class="form-control"
                        v-model="form.country_code"
                        required
                        placeholder="e.g. KE, UG, TZ"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label">Zipcode</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="form.zip_code"
                        placeholder="Postal / ZIP code"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-light me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  class="btn btn-primary"
                  :disabled="submitting || provisioningWorkspace"
                >
                  <span
                    v-if="submitting || provisioningWorkspace"
                    class="spinner-border spinner-border-sm me-1"
                  ></span
                  >{{
                    provisioningWorkspace
                      ? "Provisioning workspace..."
                      : submitting
                        ? "Saving..."
                        : "Save"
                  }}
                </button>
              </div>
            </div>

            <!-- SOCIAL TAB -->
            <div
              class="tab-pane fade"
              id="social-profile"
              role="tabpanel"
              aria-labelledby="social-profile-tab"
              tabindex="0"
            >
              <div class="modal-body pb-0">
                <div class="row">
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label">Facebook</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="form.facebook_profile"
                        placeholder="Facebook page URL"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label">Twitter</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="form.twitter_profile"
                        placeholder="Twitter/X handle or URL"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label">LinkedIn</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="form.linkedin_profile"
                        placeholder="LinkedIn company profile URL"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label">Skype</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="form.skype_profile"
                        placeholder="Skype ID"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label">Whatsapp</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="form.whatsapp_profile"
                        placeholder="WhatsApp business number"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label">Instagram</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="form.instagram_profile"
                        placeholder="Instagram handle or URL"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-light me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  class="btn btn-primary"
                  :disabled="submitting || provisioningWorkspace"
                >
                  <span
                    v-if="submitting || provisioningWorkspace"
                    class="spinner-border spinner-border-sm me-1"
                  ></span
                  >{{
                    provisioningWorkspace
                      ? "Provisioning workspace..."
                      : submitting
                        ? "Saving..."
                        : "Save"
                  }}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- /Add Company -->

  <!-- Delete Modal -->
  <div class="modal fade" id="delete_modal">
    <div class="modal-dialog modal-dialog-centered modal-sm">
      <div class="modal-content">
        <div class="modal-body text-center">
          <span class="avatar avatar-xl bg-transparent-danger text-danger mb-3">
            <i class="ti ti-trash-x fs-36"></i>
          </span>
          <h4 class="mb-1">Confirm Deletion</h4>
          <p class="mb-3">
            Are you sure you want to delete {{ deleteCompany?.company_name }}?
            This action cannot be undone.
          </p>
          <div class="d-flex justify-content-center">
            <button
              class="btn btn-light me-3"
              data-bs-dismiss="modal"
              @click="companyToDelete = null"
            >
              Cancel
            </button>
            <button
              class="btn btn-danger"
              @click="confirmDelete"
              :disabled="deleting"
            >
              <span
                v-if="deleting"
                class="spinner-border spinner-border-sm me-1"
              ></span>
              Yes, Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Delete Modal -->

  <!-- Admin Credentials Modal -->
  <div class="modal fade" id="company_admin_credentials">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Tenant Admin Access</h4>
          <button
            type="button"
            class="btn-close custom-btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i class="ti ti-x"></i>
          </button>
        </div>
        <div class="modal-body" v-if="createdAdminAccess">
          <div
            v-if="createdAdminAccess?.workspaceProvisionFailed"
            class="alert alert-danger d-flex align-items-start gap-2"
          >
            <i class="ti ti-alert-circle fs-18 mt-1"></i>
            <div>
              <div class="fw-semibold">Workspace provisioning failed.</div>
              <div class="small mb-0">
                {{
                  createdAdminAccess.workspaceProvisionMessage ||
                  "The company was saved, but the tenant workspace could not be created. Retry from the company details page."
                }}
              </div>
            </div>
          </div>

          <div class="alert alert-success d-flex align-items-start gap-2">
            <i class="ti ti-circle-check fs-18 mt-1"></i>
            <div>
              <div class="fw-semibold">Company created successfully.</div>
              <div class="small mb-0">
                Save these tenant admin details before closing this window and
                share them with the client securely.
              </div>
            </div>
          </div>

          <div class="border rounded p-3 mb-3">
            <div class="mb-2">
              <span class="text-muted d-block small">Admin Name</span>
              <strong>{{ createdAdminAccess.admin_user?.name || "Admin" }}</strong>
            </div>
            <div class="mb-2">
              <span class="text-muted d-block small">Admin Email</span>
              <div class="d-flex align-items-center gap-2">
                <strong class="mb-0">{{
                  createdAdminAccess.admin_user?.email || "Not available"
                }}</strong>
                <button
                  v-if="createdAdminAccess.admin_user?.email"
                  type="button"
                  class="btn btn-sm btn-link p-0 text-muted copy-credential-btn"
                  title="Copy email"
                  aria-label="Copy admin email"
                  @click="
                    copyAdminCredential(
                      'Email',
                      createdAdminAccess.admin_user?.email
                    )
                  "
                >
                  <i class="ti ti-copy"></i>
                </button>
              </div>
            </div>
            <div class="mb-0">
              <span class="text-muted d-block small">Temporary Password</span>
              <template v-if="createdAdminAccess.temp_password">
                <div class="d-flex align-items-center gap-2">
                  <strong class="mb-0">{{
                    createdAdminAccess.temp_password
                  }}</strong>
                  <button
                    type="button"
                    class="btn btn-sm btn-link p-0 text-muted copy-credential-btn"
                    title="Copy temporary password"
                    aria-label="Copy temporary password"
                    @click="
                      copyAdminCredential(
                        'Password',
                        createdAdminAccess.temp_password
                      )
                    "
                  >
                    <i class="ti ti-copy"></i>
                  </button>
                </div>
              </template>
              <template v-else>
                <span class="text-muted">
                  No temporary password was generated. An existing user account
                  was linked to this company.
                </span>
              </template>
            </div>
          </div>

          <div class="alert alert-warning mb-2">
            Ask the tenant admin to change this password immediately after the
            first login.
          </div>

          <div class="alert alert-light border mb-0">
            <div class="fw-semibold mb-1">Next step</div>
            <div class="small mb-0">
              <template v-if="createdAdminAccess?.workspaceProvisionFailed">
                Fix workspace provisioning, then open
                <strong>Migration Center</strong>
                to import the client's existing data.
              </template>
              <template v-else>
                You can now continue to
                <strong>Migration Center</strong>
                to import the client's existing data into this company.
              </template>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-primary"
            data-bs-dismiss="modal"
          >
            Done
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- /Admin Credentials Modal -->
</template>

<script setup>
import { computed, reactive, ref, watch, onMounted, nextTick } from "vue";
import { useCompanyStore } from "@/stores/companyStore";
import { usePlanStore } from "@/stores/planStore";
import { countries as countryList } from "@/utils/countryData";
import { isTenancyFrontendEnabled } from "@/utils/hostname";
import tenantService from "@/services/super-admin/tenantService";
import { toast } from "@/utils/toast";
import * as bootstrap from "bootstrap";
import {
  TIMEZONE_OPTIONS,
  COUNTRY_DEFAULT_TIMEZONE,
  normalizeTimezoneValue,
} from "@/utils/timezoneOptions";

// Props/Emits (pass company for edit mode; emit refresh on save)
const props = defineProps({
  company: { type: Object, default: null }, // null => create, object => edit
  deleteCompany: { type: Object, default: null }, // Company to delete
});
const emit = defineEmits([
  "company-updated",
  "company-deleted",
  "modal-closed",
]);

// Store
const companyStore = useCompanyStore();
const planStore = usePlanStore();
const submitting = ref(false);
const provisioningWorkspace = ref(false);
const deleting = ref(false);
const companyToDelete = ref(null);
const createdAdminAccess = ref(null);
const workspaceProvisionFailed = ref(false);
const workspaceProvisionMessage = ref("");

const countryQuery = ref("");

// Currencies incl. 3 East Africa
const DolarSel = [
  "Select",
  "Kenyan Shilling (KES)",
  "Ugandan Shilling (UGX)",
  "Tanzanian Shilling (TZS)",
  "Rwandan Franc (RWF)",
  "US Dollar (USD)",
  "Euro (EUR)",
  "British Pound (GBP)",
  "Japanese Yen (JPY)",
  "Chinese Yuan (CNY)",
  "Indian Rupee (INR)",
  "South African Rand (ZAR)",
  "Canadian Dollar (CAD)",
];

const CrmStat = ["Active", "Inactive"];
const onboardingOptions = ["admin_onboarded", "migrated", "self_signup"];
const tenancyEnabled = computed(() => isTenancyFrontendEnabled());
const slugManuallyEdited = ref(false);
const slugPreviewUrl = ref("");

const assignablePlans = computed(() =>
  (planStore.plans || []).filter(
    (plan) =>
      plan &&
      plan.status === "active" &&
      !plan.is_contact_sales
  )
);

function defaultPlanId() {
  const plans = assignablePlans.value;
  const basic = plans.find((plan) => plan.slug === "basic-plan");
  return String((basic || plans[0])?.id || "");
}

const timezones = TIMEZONE_OPTIONS;

// Map human-readable currency label to ISO currency code
const currencyCodeMap = {
  "Kenyan Shilling (KES)": "KES",
  "Ugandan Shilling (UGX)": "UGX",
  "Tanzanian Shilling (TZS)": "TZS",
  "Rwandan Franc (RWF)": "RWF",
  "US Dollar (USD)": "USD",
  "Euro (EUR)": "EUR",
  "British Pound (GBP)": "GBP",
  "Japanese Yen (JPY)": "JPY",
  "Chinese Yuan (CNY)": "CNY",
  "Indian Rupee (INR)": "INR",
  "South African Rand (ZAR)": "ZAR",
  "Canadian Dollar (CAD)": "CAD",
};

// Map country name to 2-letter ISO-ish country code
const countryCodeMap = {
  Kenya: "KE",
  Uganda: "UG",
  Tanzania: "TZ",
  Rwanda: "RW",
  // you can extend later if needed
};

const countryTimezoneMap = COUNTRY_DEFAULT_TIMEZONE;

// Filter countries by search text
const filteredCountries = computed(() => {
  const q = countryQuery.value.trim().toLowerCase();
  if (!q) return countryList;
  return countryList.filter((c) => c.country.toLowerCase().includes(q));
});

// When user chooses a country from dropdown
function chooseCountry(c) {
  form.country = c.country;
  countryQuery.value = "";
}

const isEditMode = computed(() => !!(props.company && props.company.id));
const showWorkspaceProvision = computed(
  () => tenancyEnabled.value && !isEditMode.value
);

function defaultForm() {
  return {
    // basic
    logo: null,
    imageUrl: "",
    company_name: "",
    email: "",
    kra_pin: "",
    phone: "",
    phone_two: "",
    fax: "",
    status: "",
    onboarding_source: "admin_onboarded",
    plan_id: defaultPlanId(),
    provision_workspace: false,
    workspace_slug: "",
    currency: "",
    currency_code: "", // NEW
    timezone: "", // NEW
    website_url: "",
    about: "",
    // address
    address: "",
    state: "",
    country: "",
    country_code: "", // NEW
    zip_code: "",
    // social (match template v-models)
    facebook_profile: "",
    twitter_profile: "",
    linkedin_profile: "",
    skype_profile: "",
    whatsapp_profile: "",
    instagram_profile: "",
  };
}

const form = reactive(defaultForm());

// Watch for edit mode
watch(
  () => props.company,
  (newCompany, oldCompany) => {
    console.log("Company prop changed:", { newCompany, oldCompany }); // Debug log

    resetForm();

    if (newCompany && newCompany.id) {
      nextTick(() => {
        populateForm(newCompany);
      });
    }
  },
  { immediate: true, deep: true }
);

// Auto-fill currency_code when user selects a currency
watch(
  () => form.currency,
  (val) => {
    if (!val) {
      form.currency_code = "";
      return;
    }
    const code = currencyCodeMap[val];
    if (code) {
      form.currency_code = code;
    }
  }
);

// Auto-fill country_code and default timezone when user selects a country
watch(
  () => form.country,
  (val) => {
    if (!val) {
      form.country_code = "";
      return;
    }

    const code = countryCodeMap[val];
    if (code) {
      form.country_code = code;

      // Only set timezone if it's still empty so user can override manually
      if (!form.timezone) {
        const tz = countryTimezoneMap[code];
        if (tz) {
          form.timezone = tz;
        }
      }
    }
  }
);

function slugify(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

watch(
  () => form.company_name,
  (name) => {
    if (!tenancyEnabled.value || slugManuallyEdited.value || isEditMode.value) return;
    form.workspace_slug = slugify(name);
  }
);

watch(
  () => form.workspace_slug,
  async (slug) => {
    const normalized = slugify(slug);
    if (!normalized) {
      slugPreviewUrl.value = "";
      return;
    }

    try {
      const res = await tenantService.checkSlug(normalized);
      slugPreviewUrl.value = res?.data?.preview_url || "";
    } catch {
      slugPreviewUrl.value = "";
    }
  }
);

watch(
  () => form.onboarding_source,
  (source) => {
    if (source === "migrated" && tenancyEnabled.value && !isEditMode.value) {
      form.provision_workspace = true;
    }
  }
);

function populateForm(company) {
  console.log("Populating form with:", company); // Debug log

  form.company_name = company.company_name || "";
  form.email = company.email || "";
  form.kra_pin = company.kra_pin || "";
  form.phone = company.phone || "";
  form.phone_two = company.phone_two || "";
  form.fax = company.fax || "";
  form.status = company.status || "Active";
  form.onboarding_source = company.onboarding_source || "admin_onboarded";
  form.currency = company.currency || "";
  form.currency_code = company.currency_code || ""; // NEW
  form.timezone = normalizeTimezoneValue(company.timezone);
  form.website_url = company.website_url || "";
  form.about = company.about || "";
  form.address = company.address || "";
  form.state = company.state || "";
  form.country = company.country || "";
  form.country_code = company.country_code || ""; // NEW
  form.zip_code = company.zip_code || "";
  form.facebook_profile = company.facebook_profile || "";
  form.twitter_profile = company.twitter_profile || "";
  form.linkedin_profile = company.linkedin_profile || "";
  form.skype_profile = company.skype_profile || "";
  form.whatsapp_profile = company.whatsapp_profile || "";
  form.instagram_profile = company.instagram_profile || "";
  form.imageUrl = company.logo_url || "";
}

// add near other refs
const companyForm = ref(null);

function goTab(id) {
  document.getElementById(id)?.click();
}

function isBasicInvalid() {
  return (
    !form.company_name ||
    !form.email ||
    !form.kra_pin ||
    !form.phone ||
    !form.currency_code || // mandatory
    !form.timezone // mandatory
  );
}

function isAddressInvalid() {
  return (
    !form.address || !form.country || !form.country_code // mandatory
  );
}

// Image preview & removal
function onImageChange(e) {
  const file = e.target.files?.[0];
  if (!file) {
    form.logo = null;
    form.imageUrl = "";
    return;
  }
  if (!file.type?.startsWith("image/")) {
    console.warn("Selected file is not an image");
    form.logo = null;
    form.imageUrl = "";
    return;
  }
  form.logo = file;
  const reader = new FileReader();
  reader.onload = (evt) => (form.imageUrl = evt.target.result);
  reader.readAsDataURL(file);
}

function removeImage() {
  form.logo = null;
  form.imageUrl = "";
}

function appendIf(fd, key, val) {
  if (val !== null && val !== undefined && val !== "") fd.append(key, val);
}

async function submitForm() {
  const nativeInvalid = companyForm.value && !companyForm.value.checkValidity();

  // Cross-tab checks (vue-select etc.)
  const basicInvalid = isBasicInvalid();
  const addressInvalid = isAddressInvalid();

  if (nativeInvalid || basicInvalid || addressInvalid) {
    if (basicInvalid) {
      const tabTrigger = document.getElementById("info-tab");
      if (tabTrigger) {
        const tab = new bootstrap.Tab(tabTrigger);
        tab.show();
      }
    } else if (addressInvalid) {
      const tabTrigger = document.getElementById("address-tab");
      if (tabTrigger) {
        const tab = new bootstrap.Tab(tabTrigger);
        tab.show();
      }
    }

    setTimeout(() => {
      companyForm.value?.reportValidity?.();
    }, 100);

    return;
  }

  submitting.value = true;
  workspaceProvisionFailed.value = false;
  workspaceProvisionMessage.value = "";
  try {
    const hasLogo =
      form.logo instanceof File && form.logo.type?.startsWith("image/");

    // Prefer JSON (same style as public signup) unless a file is attached.
    // Multipart uploads are more often flagged by Imunify360 bot-protection.
    let payload;
    if (hasLogo) {
      payload = new FormData();
      payload.append("logo", form.logo, form.logo.name);
      payload.append("create_admin_user", "1");
      if (form.company_name) {
        payload.append("admin_name", form.company_name);
      }
    } else {
      payload = {
        create_admin_user: true,
        admin_name: form.company_name || undefined,
      };
    }

    const fieldMappings = {
      company_name: "company_name",
      email: "email",
      kra_pin: "kra_pin",
      phone: "phone",
      phone_two: "phone_two",
      fax: "fax",
      status: "status",
      onboarding_source: "onboarding_source",
      plan_id: "plan_id",
      currency: "currency",
      currency_code: "currency_code",
      timezone: "timezone",
      website_url: "website_url",
      about: "about",
      address: "address",
      state: "state",
      country: "country",
      country_code: "country_code",
      zip_code: "zip_code",
      facebook_profile: "facebook_profile",
      twitter_profile: "twitter_profile",
      linkedin_profile: "linkedin_profile",
      skype_profile: "skype_profile",
      whatsapp_profile: "whatsapp_profile",
      instagram_profile: "instagram_profile",
    };

    Object.entries(fieldMappings).forEach(([formKey, fdKey]) => {
      if (isEditMode.value && formKey === "plan_id") {
        return;
      }
      const value = form[formKey];
      if (value !== null && value !== undefined && value !== "") {
        if (payload instanceof FormData) {
          payload.append(fdKey, value);
        } else {
          payload[fdKey] = value;
        }
      }
    });

    if (isEditMode.value) {
      const editPayload = hasLogo ? payload : { ...payload };
      if (editPayload instanceof FormData) {
        editPayload.append("_method", "PUT");
      }
      await companyStore.updateCompany(props.company.id, editPayload);
    } else {
      const result = await companyStore.createCompany(payload);
      const companyId = result?.company?.id || result?.id;
      if (!companyId) {
        throw new Error("Company was not created. Check API response / network tab.");
      }

      if (result?.admin_user) {
        createdAdminAccess.value = {
          admin_user: result.admin_user,
          temp_password: result.temp_password || null,
        };
      }

      submitting.value = false;

      if (form.provision_workspace && companyId) {
        provisioningWorkspace.value = true;
        try {
          const migrateRes = await tenantService.migrateCompanyToTenant(companyId, {
            slug: form.workspace_slug || undefined,
          });
          workspaceProvisionFailed.value = false;
          workspaceProvisionMessage.value =
            migrateRes?.data?.message || "Tenant workspace provisioned.";
          toast(workspaceProvisionMessage.value, "success");
        } catch (provisionError) {
          workspaceProvisionFailed.value = true;
          workspaceProvisionMessage.value =
            provisionError?.response?.data?.message ||
            "Company created, but workspace provisioning failed.";

          try {
            const workspaceRes = await tenantService.getCompanyWorkspace(companyId);
            if (workspaceRes?.data?.has_workspace) {
              workspaceProvisionFailed.value = false;
              workspaceProvisionMessage.value =
                workspaceRes?.data?.workspace_url
                  ? `Workspace is ready at ${workspaceRes.data.workspace_url}`
                  : "Workspace provisioned successfully.";
              toast(workspaceProvisionMessage.value, "success");
            } else {
              toast(workspaceProvisionMessage.value, "error");
            }
          } catch {
            toast(workspaceProvisionMessage.value, "error");
          }
        } finally {
          provisioningWorkspace.value = false;
        }
      }

      if (createdAdminAccess.value) {
        createdAdminAccess.value = {
          ...createdAdminAccess.value,
          workspaceProvisionFailed: workspaceProvisionFailed.value,
          workspaceProvisionMessage: workspaceProvisionMessage.value,
        };
      }
    }

    emit("company-updated");
    closeModal("add_company");
    if (!isEditMode.value && createdAdminAccess.value) {
      nextTick(() => showModal("company_admin_credentials"));
    }
  } catch (error) {
    console.error("Error submitting form:", error);
  } finally {
    submitting.value = false;
    provisioningWorkspace.value = false;
  }
}

async function confirmDelete() {
  if (!companyToDelete.value && !props.deleteCompany) return;

  deleting.value = true;

  try {
    const id = props.deleteCompany?.id || companyToDelete.value?.id;
    if (!id) return;

    await companyStore.deleteCompany(id);
    emit("company-updated");
    closeModal("delete_modal");
  } catch (error) {
    console.error("Error deleting company:", error);
  } finally {
    deleting.value = false;
  }
}

// Same modal closer used elsewhere
function closeModal(id) {
  const modalEl = document.getElementById(id);
  if (modalEl) {
    const instance = bootstrap.Modal.getInstance(modalEl);
    if (instance) {
      instance.hide();
    } else {
      modalEl.classList.remove("show");
      modalEl.style.display = "none";
      modalEl.setAttribute("aria-hidden", "true");
      modalEl.removeAttribute("aria-modal");
    }
  }
  document.body.classList.remove("modal-open");
  document.querySelectorAll(".modal-backdrop").forEach((b) => b.remove());
  emit("modal-closed");
}

function showModal(id) {
  const modalEl = document.getElementById(id);
  if (!modalEl) return;

  const instance =
    bootstrap.Modal.getOrCreateInstance?.(modalEl) ||
    new bootstrap.Modal(modalEl);
  instance.show();
}

function resetForm() {
  console.log("Resetting form"); // Debug log

  slugManuallyEdited.value = false;
  slugPreviewUrl.value = "";

  const defaultValues = defaultForm();
  Object.keys(defaultValues).forEach((key) => {
    form[key] = defaultValues[key];
  });

  if (!form.plan_id) {
    form.plan_id = defaultPlanId();
  }
}

async function copyAdminCredential(label, value) {
  const text = String(value || "").trim();
  if (!text) {
    toast(`No ${label.toLowerCase()} available to copy.`, "error");
    return;
  }

  try {
    if (navigator?.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
    } else {
      const input = document.createElement("textarea");
      input.value = text;
      input.setAttribute("readonly", "");
      input.style.position = "fixed";
      input.style.left = "-9999px";
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      input.remove();
    }
    toast(`${label} copied to clipboard.`, "success");
  } catch (error) {
    toast(`Failed to copy ${label.toLowerCase()}.`, "error");
  }
}

onMounted(async () => {
  console.log("Modal component mounted");

  try {
    await planStore.fetchPlans({ status: "active", per_page: 100 });
  } catch (error) {
    // planStore already toasts failures
  }

  if (!form.plan_id) {
    form.plan_id = defaultPlanId();
  }

  const addModal = document.getElementById("add_company");
  const deleteModal = document.getElementById("delete_modal");
  const credentialsModal = document.getElementById("company_admin_credentials");

  if (addModal) {
    addModal.addEventListener("hidden.bs.modal", () => {
      console.log("Modal hidden, resetting form");
      resetForm();
      emit("modal-closed");
    });

    addModal.addEventListener("shown.bs.modal", () => {
      console.log("Modal shown, current company:", props.company);
      if (props.company && props.company.id) {
        populateForm(props.company);
      } else if (!form.plan_id) {
        form.plan_id = defaultPlanId();
      }
    });
  }

  if (deleteModal) {
    deleteModal.addEventListener("hidden.bs.modal", () => {
      companyToDelete.value = null;
    });
  }

  if (credentialsModal) {
    credentialsModal.addEventListener("hidden.bs.modal", () => {
      createdAdminAccess.value = null;
      workspaceProvisionFailed.value = false;
      workspaceProvisionMessage.value = "";
    });
  }
});
</script>
